<template>
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.125 3H3.875A2.625 2.625 0 0 0 1.25 5.625v8.75A2.625 2.625 0 0 0 3.875 17h12.25a2.625 2.625 0 0 0 2.625-2.625v-8.75A2.625 2.625 0 0 0 16.125 3ZM3.875 4.75h12.25a.875.875 0 0 1 .875.875l-7 4.27-7-4.27a.875.875 0 0 1 .875-.875ZM17 14.375a.875.875 0 0 1-.875.875H3.875A.875.875 0 0 1 3 14.375V7.62l6.545 3.999a.875.875 0 0 0 .875 0L17 7.62v6.755Z"
      fill="currentColor"
    />
  </svg>
</template>
